module.exports = __webpack_public_path__ + "static/media/logo.bacb3603.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ms-layout/ms-header/logo.png
// module id = 656
// module chunks = 0